const ThumbDown = (props) => (
  <svg
    fill="#ffffff"
    width="30px"
    height="30px"
    viewBox="0 0 351.413 351.414"
    {...props}
  >
    <g>
      <g>
        <g>
          <path d="M80.608,216.845H21.879C9.815,216.845,0,205.472,0,191.505V30.541C0,16.576,9.815,5.212,21.879,5.212h58.729 
            c12.063,0,21.875,11.364,21.875,25.328v160.965C102.484,205.472,92.672,216.845,80.608,216.845z" />
        </g>
        <g>
          <path d="M195.096,346.201c-18.504,0-33.558-15.049-33.558-33.555c0-1.249,0.075-2.498,0.216-3.76 
            c-0.222-1.104-0.246-2.233-0.006-3.326c6.407-29.399-6.947-62.786-15.483-80.062c-0.739-1.488-1.457-2.936-2.147-4.251 
            c-1.291-1.495-3.035-2.504-5.005-2.87h-2.519c-0.363,0-0.937-0.036-1.378-0.09c-14.006-0.793-24.83-12.172-24.83-26.121V31.417 
            c0-14.448,11.757-26.205,26.208-26.205h181.24c0.799,0,1.567,0.099,2.294,0.288c16.976,1.789,30.012,16.081,30.012,33.278 
            c0,9.248-3.765,17.642-9.872,23.716c6.828,6.149,11.146,15.061,11.146,24.959c0,9.575-4.029,18.219-10.479,24.344 
            c6.449,6.113,10.479,14.769,10.479,24.343s-4.029,18.218-10.479,24.332c6.449,6.125,10.479,14.769,10.479,24.344 
            c0,18.506-15.055,33.566-33.567,33.566l-77.521-0.012c21.677,67.397-16.813,112.59-18.579,114.596 
            c-0.036,0.035-0.072,0.071-0.108,0.132C215.296,341.312,205.448,346.201,195.096,346.201z" />
        </g>
      </g>
    </g>
  </svg>
);

export default ThumbDown;
